"use client";

import React from "react";
import Image from "next/image";

const TypesOfWhitening: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Types of Teeth Whitening Treatments
        </h2>
        <div className="relative w-full h-[300px] md:h-[500px] my-8 rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/Photo-a-dental-professional-wearing-orange-protective-glasses-and-a-mask-using-a-blue-curing-light-wand-during-a-procedure-on-a-patient-lying-in-a-dental-chair.jpeg"
            alt="Dental professional performing a teeth whitening procedure on a patient in a dental chair"
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          If you&apos;re looking to brighten your smile, there are several teeth
          whitening treatments, each with its own benefits and effectiveness.
          Here are some of the most common options and how they compare.
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>In-Office Teeth Whitening:</strong> Professional, in-office
            whitening is the fastest and most effective way to achieve a
            dramatically whiter smile. In just one visit (about 60&ndash;90
            minutes), high-concentration whitening agents used by a dental
            professional can lighten your teeth several shades.
          </li>
          <li>
            <strong>Take-Home Whitening Kits:</strong> Custom take-home kits
            offer a convenient way to gradually brighten your smile at home. With
            custom trays and professional-grade gel used daily or overnight, you
            can achieve consistent results over one to two weeks.
          </li>
          <li>
            <strong>Over-the-Counter Whitening Strips:</strong> Over-the-counter
            whitening strips are an affordable option for improving mild tooth
            discoloration. They use lower-strength whitening agents applied
            daily, but the results are typically less even than with professional
            treatments.
          </li>
          <li>
            <strong>Charcoal and Natural Whitening Methods:</strong> Charcoal
            and other natural whitening methods mainly remove surface stains
            rather than deeply whitening teeth. Overusing these abrasive products
            can damage enamel and increase sensitivity over time.
          </li>
          <li>
            <strong>Hydrogen Peroxide vs. Carbamide Peroxide:</strong> Hydrogen
            peroxide works quickly to break down stains, making it ideal for
            in-office whitening treatments. Carbamide peroxide releases more
            slowly, making it better suited for take-home kits and patients with
            sensitivity.
          </li>
        </ul>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
          How to Choose the Right Treatment
        </h3>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Choosing the right whitening option depends on your goals, sensitivity
          level, and how quickly you want results.
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>For instant results:</strong> In-office whitening is your
            best option
          </li>
          <li>
            <strong>For convenience:</strong> Take-home trays provide
            flexibility
          </li>
          <li>
            <strong>For budget-friendly options:</strong> OTC products can help
            with minor stains
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          At Smile4Me Dental Care, we guide every patient through a personalized
          consultation to recommend the safest and most effective treatment based
          on their smile goals.
        </p>
      </div>
    </section>
  );
};

export default TypesOfWhitening;
